import { FormGroup, Input, Label } from "reactstrap";
import { Search } from "../../../../../constants";
import EmailTabs from "./EmailTabs";
import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { EmailFilterOption } from "../../../../../data/applications/LetterBox";
const EmailHeader = () => {
  const [show, setShow] = useState(false);

  return (
    <div className="mail-header-wrapper">
      <div className="mail-header">
        <FormGroup check inline className="m-0">
          <Input className="checkbox-primary" type="checkbox" />
          <Label check />
          <EmailTabs />
        </FormGroup>
      </div>
      <div className="mail-body">
        <div className="mail-search d-flex-align-items-center">
          <Input type="text" placeholder={Search} />
          <i className="fa fa-search" />
        </div>
        <div className="light-square bg-light-info txt-info">
          <i className="fa fa-refresh" />
        </div>
        <div className="light-square bg-light-danger txt-danger">
          <i className="fa fa-trash" />
        </div>
        <Dropdown isOpen={show} toggle={() => setShow(!show)}>
          <DropdownToggle color="transparent" className="border-0 px-0 light-square bg-light-primary txt-primary">
            <i className="fa fa-ellipsis-v" />
          </DropdownToggle>
          <DropdownMenu end className="dropdown-block">
            {EmailFilterOption.map((data, i) => (
              <DropdownItem key={i}>{data}</DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};

export default EmailHeader;
